import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query operators($id: Int!) {
    operatorsSearchActivities(id: $id) {
        operators {
          id
          fullName
        }
      }
}`;

function getOperatorsForCurrentOperatorSearch({ id }) {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
    variables: { id: parseInt(id, 10) },
  }).then((data) => data.data.operatorsSearchActivities.operators)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        throw err.graphQLErrors[0].message;
      } else {
        throw err;
      }
    });
}

export default getOperatorsForCurrentOperatorSearch;
